import {User, USER_ROLES} from '../interfaces/user.interface';

export function isUserAdmin({role}: Pick<User, 'role'>): boolean {
  return role === USER_ROLES.ADMIN;
}
